// @flow

import type { Answer } from '../models/answer';
import type { ApiAnswer } from '~/sdk/feedback/dtos/api-answer';

export function convertToDto(answer: Answer): ApiAnswer {
  const apiAnswer: ApiAnswer = {
    questionId: answer.questionId,
  };

  if (answer.rating) {
    apiAnswer.rating = answer.rating;
  }
  if (answer.comment) {
    apiAnswer.answer = answer.comment;
  }

  return apiAnswer;
}



// WEBPACK FOOTER //
// ./app/CaptureFeedback/Form/answer-mapper.js